import React from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import {
  ReferralHome,
  MyReferralsScreen,
  ReferralFAQ,
  PointRedemption,
  RedemptionStatus,
  ReferralPickup,
  ReferralRewardScreen,
  RedemptionOrderDetailsScreen,
  ShareScreen,
} from "../screens/subscriber/referral";

const Referral = () => {
  const match = useRouteMatch();
  return (
    <Desktop phonebg={"white"}>
      <Switch>
        <Route
          path={`${match.path}/myreferrals`}
          render={() => <MyReferralsScreen />}
        />
        <Route
          path={`${match.path}/referralfaq`}
          render={() => <ReferralFAQ />}
        />
        <Route
          path={`${match.path}/pointredemption`}
          render={() => <PointRedemption />}
        />
        <Route
          path={`${match.path}/redemptionstatus`}
          render={() => <RedemptionStatus />}
        />
        <Route
          path={`${match.path}/referralpickup`}
          render={() => <ReferralPickup />}
        />
        <Route
          path={`${match.path}/referralreward`}
          render={() => <ReferralRewardScreen />}
        />
        <Route
          path={`${match.path}/referralrewardstatus`}
          render={() => <RedemptionOrderDetailsScreen />}
        />
        <Route path={`${match.path}/share`} render={() => <ShareScreen />} />
        <Route path={`${match.path}/`} render={() => <ReferralHome />} />
      </Switch>
    </Desktop>
  );
};

export default Referral;
